import * as authSelectors from './auth/selectors';
import * as apiSelectors from './api/selectors';

export default {
	auth: authSelectors,
	api: apiSelectors,
};
